import { EventEmitter, Input, Output, ViewChild, Directive } from '@angular/core';
import {NbCheckboxComponent} from '@nebular/theme';
import {QuoteRowObject} from '../../class/quote/quote-row-object';
import {Util} from '../../util/util';

@Directive()
export abstract class AbstractQuoteRow<T> {

  @Input()
  title: string;

  @ViewChild('rowCheckbox')
  selectedObject: NbCheckboxComponent;

  @Input()
  safeguardType: number;

  @Input()
  isEditing = false;

  @Output()
  public onRowUpdate = new EventEmitter<QuoteRowObject>();

  selectedCover: number;

  public onRowUpdated() {
    let deltaPercent = 0;

    if (this.selectedObject.checked) {

      const maxCover = Util.getCover(this.getRowObject(), this.safeguardType);

      // subtract capValue
      const deltaCover = maxCover - this.selectedCover;

      deltaPercent = Math.round((100 - ((deltaCover / maxCover) * 100)));
    }

    this.onRowUpdate.emit({value: deltaPercent, type: this.safeguardType, obj: this.getRowObject()});
  }

  abstract getRowObject(): T;
}
